// TOUR-3 — pick role-specific step copy from KB artifact variants.

import type { FireflyTourStepCopy } from "./tourTypes";

export type HasRoleFn = (...roles: string[]) => boolean;

export function normalizeTourStepCopy(
  copy: FireflyTourStepCopy | FireflyTourStepCopy[],
  hasRole: HasRoleFn,
): FireflyTourStepCopy {
  const variants = Array.isArray(copy) ? copy : [copy];
  if (variants.length === 0) {
    return { body: "" };
  }

  for (const variant of variants) {
    if (!variant.roles?.length) continue;
    if (variant.roles.some((role) => hasRole(role))) {
      return variant;
    }
  }

  const unscoped = variants.find((v) => !v.roles?.length);
  return unscoped ?? variants[0];
}
